(() => {
  const initialize = (root) => {
    if (root.dataset.v22CarouselReady === 'true') return;
    const viewport = root.querySelector('.v22-starter-carousel__viewport');
    const slides = Array.from(root.querySelectorAll('.v22-starter-carousel__slide'));
    const captions = Array.from(root.querySelectorAll('[data-v22-carousel-caption]'));
    const dots = Array.from(root.querySelectorAll('[data-v22-carousel-dot]'));
    if (!viewport || slides.length !== 3 || captions.length !== 3 || dots.length !== 3) return;
    root.dataset.v22CarouselReady = 'true';
    let current = 0;
    let settleTimer;

    const update = (index) => {
      current = index;
      captions.forEach((caption, i) => { caption.hidden = i !== index; });
      dots.forEach((dot, i) => { dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    };
    const go = (index) => {
      const target = (index + slides.length) % slides.length;
      update(target);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      viewport.scrollTo({ left: target * viewport.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const syncFromScroll = () => {
      if (!viewport.clientWidth) return;
      const index = Math.min(slides.length - 1, Math.max(0, Math.round(viewport.scrollLeft / viewport.clientWidth)));
      update(index);
    };

    root.querySelector('[data-v22-carousel-prev]').addEventListener('click', () => go(current - 1));
    root.querySelector('[data-v22-carousel-next]').addEventListener('click', () => go(current + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); go(current + 1); }
      else if (event.key === 'ArrowLeft') { event.preventDefault(); go(current - 1); }
      else if (event.key === 'Home') { event.preventDefault(); go(0); }
      else if (event.key === 'End') { event.preventDefault(); go(slides.length - 1); }
    });
    viewport.addEventListener('scroll', () => {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(syncFromScroll, 100);
    }, { passive: true });
  };
  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-v22-starter-carousel]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
